import { getLevelArrayMetric as r } from "../index4.js";
import { getLevelNonResidentialArea as t } from "../level-metrics/index26.js";
const a = (e) => r(e, t);
export {
  a as getLevelArrayNonResidentialArea
};
//# sourceMappingURL=index12.js.map
